export class UserMenuItemRegistry {
    _userMenuItems;
    constructor() {
        this._userMenuItems = Object.freeze([]);
    }
    add(userMenuItems) {
        // Create a new array so the routes array is immutable.
        this._userMenuItems = Object.freeze([...this._userMenuItems, ...userMenuItems.filter(x => x)]);
    }
    get userMenuItems() {
        return this._userMenuItems;
    }
}
